import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import InsightsHero from './components/InsightsHero';
import InsightsList from './components/InsightsList';

export default function InsightsPage() {
  return (
    <div className="min-h-screen bg-[#fafaf8]">
      <Navbar />
      <main>
        <InsightsHero />
        <InsightsList />
      </main>
      <Footer />
    </div>
  );
}
